import React, { useState, useEffect, useRef } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import printJS from "print-js"; // If using npm
import moment from "moment";
import AlertMessage from "../../AlertMessage";

function NirgamDoc({ submitted, formData,isStudentActive }) {
  const [schoolData, setSchoolData] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false);
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "English"
  );
  const [logoURL, setLogoURL] = useState("");
  const [loading, setLoading] = useState(true);
  const [udiseNumber, setUdiseNumber] = useState("");
  const [documentNumber, setDocumentNumber] = useState(null);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  useEffect(() => {
    const schoolUdiseNumber = localStorage.getItem("udiseNumber");
    if (schoolUdiseNumber) {
      fetchSchoolData(schoolUdiseNumber);
    }
  }, []);

  useEffect(() => {
    const schoolUdiseNumber = localStorage.getItem("udiseNumber");
    if (schoolUdiseNumber) {
      setUdiseNumber(schoolUdiseNumber);
    }
  }, []);

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    handleResize(); // Check initial screen size
    window.addEventListener("resize", handleResize); 
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openDatabase = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        // Define your object stores here if needed
        db.createObjectStore('studentData', { keyPath: 'id' });
      };
  
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
  
      request.onerror = (event) => {
        reject('Error opening database: ' + event.target.errorCode);
      };
    });
  };

  const fetchSchoolData = async (udiseNumber) => {
    try {
      const request = indexedDB.open('SchoolManagementDB', 1);

      request.onsuccess = async (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
            setLogoURL(data.schoolLogo);
          }
          setLoading(false);
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
          setLoading(false);
        };
      };

      request.onerror = (event) => {
        console.error("Error opening IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error fetching school data:", error);
      setLoading(false);
    }
  };

  const [birthPlaceTop, setBirthPlaceTop] = useState('6.95in'); // State for top position
    const birthPlaceRef = useRef(null); // Ref for the birth place text
  
  useEffect(() => {
    const adjustBirthPlaceText = () => {
      const el = birthPlaceRef.current;
      if (!el) return;
  
      let fontSize = 16;
      el.style.fontSize = `${fontSize}px`;
  
      const getLineCount = () => {
        const computedStyle = window.getComputedStyle(el);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const height = el.offsetHeight;
        return {
          lines: Math.round(height / lineHeight),
          lineHeight,
        };
      };
  
      let { lines } = getLineCount();
      let fontReduced = false;
  
      // Reduce font size if more than 1 line
      while (lines > 1 && fontSize > 12) {
        fontSize -= 2;
        el.style.fontSize = `${fontSize}px`;
        fontReduced = true;
        ({ lines } = getLineCount()); // Recalculate lines
      }
  
      // Check final line count after any reduction
      const finalLines = getLineCount().lines;
  
      // Top logic based on final line count
      if (finalLines === 1) {
        setBirthPlaceTop('6.95in'); // Single line — normal position
      } else {
        setBirthPlaceTop('6.77in'); // Multiple lines — move up slightly
      }
    };
  
    // Run after DOM update
    setTimeout(adjustBirthPlaceText, 0);
  }, [formData.birthPlace]);
  
  const renderContent = () => {
    if (!schoolData || !formData) return null;

    return (
      <>
        <div
          style={{
            marginBottom: "300px",
            position: "absolute",
            top: "0.80in",
            bottom: "0in",
            right: "0.35in",
            width: "7.6in",
            height: "11in",
            fontFamily: "'NotoSansDevanagari', sans-serif",
            border: "0.03in solid black",
            boxSizing: "border-box",
            padding: "0.2in",
            "@media (max-width: 1200px)": {
              right: "0in",
              width: "8in",
              height: "11in",
            },
            "@media (max-width: 992px)": {
              right: "0in",
              width: "8.5in",
              height: "11.5in",
            },
            "@media (max-width: 768px)": {
              top: "0.2in",
              right: "0in",
              width: "100%",
              height: "auto",
              padding: "0.1in",
            },
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "0.1in",
              left: "0in",
              right: "0in",
              textAlign: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {schoolData.sansthaName && (
                <div
                  style={{
                    fontSize: "11px",
                    fontWeight: "bold",
                    wordWrap: "break-word",
                    textAlign: "center",
                    marginBottom: "-10px",
                  }}
                >
                  {schoolData.sansthaName}
                </div>
              )}
              <div
                style={{
                  fontSize: "19px",
                  fontWeight: "bold",
                  wordWrap: "break-word",
                  textAlign: "center",
                  marginTop: schoolData.sansthaName ? "10px" : "0px",
                }}
              >
                {schoolData.schoolName}
              </div>
              <div
                style={{
                  position: "absolute",
                  top: "0.4in",
                  left: "15%",
                  right: "15%",
                  boxSizing: "border-box",
                  padding: "0",
                }}
              >
                <div
                  style={{
                    margin: "0 auto",
                    width: "100%",
                    maxWidth: "calc(100% - 0.6in)",
                    boxSizing: "border-box",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{ fontSize: "14px", margin: "4px 0", padding: "0" }}
                  >
                    {language === "English" ? (
                      <>
                        <strong>Taluka : </strong>
                        {schoolData.taluka},<strong> District :</strong>{" "}
                        {schoolData.jilha}
                      </>
                    ) : (
                      <>
                        <strong> तालुका : </strong>
                        {schoolData.taluka}, <strong>जिल्हा :</strong>{" "}
                        {schoolData.jilha}
                      </>
                    )}
                  </p>
                  <p
                    style={{ fontSize: "14px", margin: "2px 0", padding: "0" }}
                  >
                    {language === "English" ? (
                      <>
                        <strong>UDISE No :</strong> {schoolData.udiseNumber},{" "}
                        <strong>Board :</strong> {schoolData.boardName}
                      </>
                    ) : (
                      <>
                        <strong>UDISE क्र :</strong> {schoolData.udiseNumber},{" "}
                        <strong>बोर्ड :</strong> {schoolData.boardName}
                      </>
                    )}
                  </p>
                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: "1.4in",
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              {logoURL && (
                <img
                  src={logoURL}
                  alt="School Logo"
                  style={{
                    position: "absolute",
                    top: "0.45in",
                    left: "0.2in",
                    width: "115px",
                    height: "115px",
                    marginRight: "10px",
                  }}
                />
              )}
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              top: "1.05in",
              left: "2.79in",
              width: "2in",
              height: "0.34in",
              textAlign: "center",
              border: "0.025in solid black",
              margin: "10px 0",
              backgroundColor: "black",
              color: "white",
              borderRadius: "0.1in",
            }}
          >
            <h3
              style={{
                color: "white",
                fontSize: "16px",
                margin: "6px 0",
                fontWeight: "bold",
              }}
            ></h3>
            <p>
              {language === "English"
                ? "Entrance exit passage"
                : "प्रवेश निर्गम उतारा"}
            </p>
          </div>
          <p
            style={{
              position: "absolute",
              top: "1.62in",
              left: "2.5in",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            {language === "English"
              ? "Enrollment register as student entry exit"
              : "विद्यार्थी प्रवेश निर्गम प्रमाणे नोंदणी रजिस्टर"}
          </p>
         
            {language === "English" ? (
              <p
            style={{
              position: "absolute",
              top: "1.62in",
              left: "5.8in",
              fontSize: "13px",
            }}
          >
                <strong>Medium :</strong> {schoolData.madhyam}
              </p>
            ) : (
              <p
            style={{
              position: "absolute",
              top: "1.62in",
              left: "5.9in",
              fontSize: "13px",
            }}
          >
                <strong>माध्यम :</strong> {schoolData.madhyam}
              </p>
            )}
        

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "1.85in",
              left: "0in",
              right: "0in",
            }}
          ></div>
          <div
            style={{
              borderLeft: "0.02in solid black",
              position: "absolute",
              top: "1.85in",
              left: "3.44in",
              height: "8.10in",
            }}
          ></div>
          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "2.25in",
              left: "0in",
              right: "0in",
            }}
          ></div>
          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "2.65in",
              left: "0in",
              right: "0in",
            }}
          ></div>
          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "3.1in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "1.95in", left: '0.4in' }}>
            {language === "English" ? (
              <>
                <strong>Register No </strong>
              </>
            ) : (
              <>
                <strong>प्रवेश अनुक्रमांक </strong>
              </>
            )}
          </p>
          <p style={{ position: "absolute", top: "1.95in", left: "3.5in" }}>
            {formData.registerno}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "3.5in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "2.35in", left: '0.4in' }}>
            <b>
              {language === "English"
                ? " Full Name of Student"
                : "विद्यार्थ्याचे संपूर्ण नाव"}
            </b>
          </p>
          <p style={{ position: "absolute", top: "2.35in", left: "3.5in" }}>
            {formData.stdName} {formData.stdFather} {formData.stdSurname}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "3.9in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "2.75in", left: '0.4in' }}>
            <b>{language === "English" ? "  Mother's Name" : "आईचे नाव"}</b>
          </p>
          <p style={{ position: "absolute", top: "2.75in", left: "3.5in" }}>
            {formData.stdMother}
          </p>
          <p
            style={{
              position: "absolute",
              top: "3.20in",
              left: "0.43in",
              fontSize: "15px",
            }}
          >
            <b>
              {language === "English"
                ? " Full Name of Father"
                : "वडीलाचे नाव"}
            </b>
          </p>
          <p style={{ position: "absolute", top: "3.15in", left: "3.5in" }}>
            {formData.stdFather} {formData.stdSurname}
          </p>
          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "4.3in",
              left: "0in",
              right: "0in",
            }}
          ></div>
          <p style={{ position: "absolute", top: "3.6in", left: '0.4in' }}>
            <b>{language === "English" ? "Religion" : "धर्म "}</b>
          </p>
          <p style={{ position: "absolute", top: "3.6in", left: "3.5in" }}>
            {formData.religion}
          </p>
          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "4.7in",
              left: "0in",
              right: "0in",
            }}
          ></div>
          <p style={{ position: "absolute", top: "4in", left: '0.4in' }}>
            <b>{language === "English" ? "Caste- Sub Caste" : "जात-पोटजात"}</b>
          </p>
          <p style={{ position: "absolute", top: "4in", left: "3.5in" }}>
            {formData.caste}-{formData.subCaste}
          </p>
          <p style={{ position: "absolute", top: "4.4in", left: '0.4in' }}>
            <b>
              {language === "English"
                ? "Father's Occupation"
                : "वडील / पालकांचा व्यवसाय"}
            </b>
          </p>
          <p style={{ position: "absolute", top: "4.4in", left: "3.5in" }}>
            {formData.fOccupation}
          </p>
          <p style={{ position: "absolute", top: "4.8in", left: '0.4in' }}>
            <b>{language === "English" ? "Mother Tounge" : "मातृभाषा"}</b>
          </p>
          <p style={{ position: "absolute", top: "4.8in", left: "3.5in" }}>
            {formData.motherTounge}
          </p>
          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "5.1in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "5.2in", left: '0.4in' }}>
            <b>
              {language === "English"
                ? " Aadhar Card No.  "
                : "विद्यार्थी आधार कार्ड क्र."}
            </b>
          </p>
          <p style={{ position: "absolute", top: "5.2in", left: "3.5in" }}>
            {formData.stdAdharNo}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "5.5in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "5.6in", left: '0.4in' }}>
            <b>
              {language === "English" ? " Saral Id.  " : "विद्यार्थी सरल क्र."}
            </b>
          </p>
          <p style={{ position: "absolute", top: "5.6in", left: "3.5in" }}>
            {formData.studentId}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "5.9in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "5.95in", left: '0.4in' }}>
            <b>
              {language === "English" ? " PEN No  " : "विद्यार्थी पेन क्र."}
            </b>
          </p>
          <p style={{ position: "absolute", top: "5.95in", left: "3.5in" }}>
            {formData.panId}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "6.25in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "6.30in", left: '0.4in' }}>
            <b>
              {language === "English"
                ? " Date of Birth "
                : "इ. सनप्रमाणे जन्म दिनांक"}
            </b>
          </p>
          <p style={{ position: "absolute", top: "6.60in", left: "0.4in" }}>
            <b>
              {language === "English"
                ? "(Numerical and in words) "
                : "(अंकी व अक्षरी)"}
            </b>
          </p>
          <p style={{ position: "absolute", top: "6.30in", left: "3.5in" }}>
            {moment(formData.dob).format("DD-MM-YYYY")}
          </p>
          <p style={{ position: "absolute", top: "6.60in", left: "3.5in" }}>
            {formData.dobInWords}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "6.85in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "6.95in", left: '0.4in' }}>
            <b>{language === "English" ? "Place of Birth  " : "जन्म स्थळ"}</b>
          </p>
          <p
            ref={birthPlaceRef}
            style={{
              position: 'absolute',
              top: birthPlaceTop,
              left: '3.5in',
              fontSize: '16px',
              width: '4in',
              height: 'auto',
              maxHeight: '42px', // Optional: restrict height
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            {formData.birthPlace}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "7.25in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p
            style={{
              position: "absolute",
              top: "7.29in",
              left: '0.4in',
              fontSize: "0.99em",
            }}
          >
            <b>
              {language === "English"
                ? "Previous School Name "
                : "या शाळेत येण्यापूर्वी शिकत असलेली शाळा"}
            </b>
          </p>
          <p
            style={{
              position: "absolute",
              top: "7.51in",
              left: '0.4in',
              fontSize: "0.99em",
            }}
          >
            <b>{language === "English" ? "and Class" : "व प्रवेश समयी वर्ग"}</b>
          </p>
          <p
            style={{
              position: "absolute",
              top: "7.31in",
              left: "3.5in",
              fontSize: "0.8em",
            }}
          >
            {formData.prevSchool} -  {formData.admissionClass}
          </p>
          

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "7.75in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          {/* Date of Admission Field */}
          <p style={{ position: "absolute", top: "7.85in", left: '0.4in' }}>
            <b>
              {language === "English" ? "Date of Admission " : "प्रवेश दिनांक"}
            </b>
          </p>
          <p style={{ position: "absolute", top: "7.85in", left: "3.5in" }}>
            {moment(formData.dateOfAdmission).format("DD-MM-YYYY")}{" "}
            {/* Render the updated admission date */}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "8.15in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "8.25in", left: '0.4in' }}>
            <b>{language === "English" ? "Nirgam Date " : "निर्गम तारीख"}</b>
          </p>
          <p style={{ position: "absolute", top: "8.25in", left: "3.5in" }}>
             {formatDate(formData.date)}{" "}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "8.55in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "8.65in", left: '0.4in' }}>
            <b>
              {language === "English"
                ? "Student's Conduct "
                : "निर्गम समयी वर्ग"}
            </b>
          </p>
          <p style={{ position: "absolute", top: "8.65in", left: "3.5in" }}>
            {formData.class}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "8.95in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "9.05in", left: '0.4in' }}>
            <b>
              {language === "English"
                ? "Briefly Symbol of the Student "
                : "परिचय चिन्ह विद्यार्थयााचे थोडक्यात"}
            </b>
          </p>
          <p style={{ position: "absolute", top: "9.27in", left: '0.4in' }}>
            <b>{language === "English" ? "Birth Remarks " : "दोन चिन्ह"}</b>
          </p>
          <p style={{ position: "absolute", top: "9.15in", left: "3.5in" }}>
            {formData.conduct}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "9.55in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "9.65in", left: '0.4in' }}>
            <b>{language === "English" ? "Remarks " : "विवरण"}</b>
          </p>
          <p style={{ position: "absolute", top: "9.65in", left: "3.5in" }}>
            {formData.remark}
          </p>

          <div
            style={{
              borderTop: "0.02in solid black",
              position: "absolute",
              top: "9.95in",
              left: "0in",
              right: "0in",
            }}
          ></div>

          <p style={{ position: "absolute", top: "10.00in", left: '0.4in' }}>
          {language === "English" 
  ? `The information is correct as per the General Registration of ${schoolData.schoolName},  was provided by the applicant.` 
  : `वरील विहीत नमुन्यातील माहिती ${schoolData.schoolName}, ता. ${schoolData.taluka} , जि.  ${schoolData.jilha} च्या जनरल रजिस्टर प्रमाणे बिनचूक आहे. सदर माहिती अर्जदार`}

            <b> {formData.stdName} {formData.stdFather} {formData.stdSurname}</b>
            {language === "English"
              ? "."
              : ", यांच्या मागणी वरून दिला"}
          </p>

          <p style={{ position: "absolute", top: "10.6in", left: "0.3in" }}>
            {language === "English" ? "Date :" : "दि :"} {formatDate(formData.printdate)}{" "} 
          </p>
          <p style={{ position: "absolute", top: "10.6in", right: "0.6in" }}>
            {language === "English"
              ? "Principal's Signature"
              : "मुख्याध्यापक/ प्राचार्य सही"}
          </p>
        </div>

        <div style={{ height: "200px" }}></div>
      </>
    );
  };



  const printCertificate = async () => {

    if (!isStudentActive) {
      setAlertMessage('Cannot print certificate for inactive students.');
      return;
    }

    

    try {
     // Update isActive to false for the selected student
    const selectedStudentId = `${formData.class ||''}-${formData.division || ''}-${formData.serialNo || ''}`;
    // Update in IndexedDB
    const db = await openDatabase();
    const transaction = db.transaction(['studentData'], 'readwrite');
    const objectStore = transaction.objectStore('studentData');

    const studentRequest = objectStore.get(selectedStudentId);
    studentRequest.onsuccess = (event) => {
      const student = event.target.result;
      if (student) {
        student.isActive = false; // Set isActive to false
        const updateRequest = objectStore.put(student); // Update the student in IndexedDB

        updateRequest.onsuccess = () => {
          console.log(`Updated isActive to false for student ID: ${selectedStudentId}`);
        };

        updateRequest.onerror = (error) => {
          console.error('Error updating student in IndexedDB:', error);
        };
      } else {
        console.error(`Student with ID ${selectedStudentId} not found in IndexedDB.`);
      }
    };

    // Update in Firebase
    const updates = {};
    updates[`/schoolRegister/${udiseNumber}/studentData/${formData.serialNo}/isActive`] = false; // Prepare update for Firebase

    const response = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/.json`, 
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates),
      }
    );

    if (!response.ok) {
      throw new Error('Failed to update Firebase');
    }


      await new Promise((resolve) => setTimeout(resolve, 100));

      const printContent = document.getElementById("print-content");
      if (!printContent) {
        setAlertMessage("Print content not found.");
        return;
      }

      const clone = printContent.cloneNode(true);
      clone.style.padding = "50px 381px";
      clone.style.transform = "translate(0, -70px) scale(1.08)";

      clone.querySelectorAll("p").forEach((p) => {
        p.style.margin = "0";
        p.style.padding = "0";
        p.style.lineHeight = "1.4";
      });

      const printContainer = document.createElement("div");
      printContainer.appendChild(clone);

      printJS({
        printable: printContainer.innerHTML,
        type: "raw-html",
        style: `
          @media print {
            body { margin: 0; }
            p { margin: 0; padding: 0; line-height: 1.4; }
            @page {
              size: A4 Portrait;
              margin: 8mm 8mm 8mm 9mm; /* this affects the margin in the printer settings */
            }
          }
        `,
      });
    } catch (error) {
      console.error("Error in printCertificate:", error);
      setAlertMessage("Error printing certificate");
    }
  };

  return (
    <>
      <AlertMessage message={alertMessage} show={showAlert} />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1em",
        }}
      >
        <div id="print-content" style={{ marginBottom: "230px" }}>
          {loading ? <p>Loading...</p> : renderContent()}
        </div>
        <div style={{ marginTop: "1em" }}>
           <button
  onClick={printCertificate}
  style={{
    position: "absolute",
    top: isStudentActive 
      ? (language === "English" ? "49em" : "48.8em") 
      : (language === "English" ? "56em" : "56.8em"),
       
    left: language === "English" ? "14em" : "14.7em",
    cursor: isStudentActive ? "pointer" : "not-allowed", // Change cursor based on active status
    opacity: isStudentActive ? 1 : 0.5,
  }} disabled={!isStudentActive} 
>
  Print
</button>
        </div>
      </div>
    </>
  );
}

export default NirgamDoc;
